"use strict";

/*!
 * fullpage.js Parallax Effect Extension 0.1.9 for fullPage.js v3
 * https://github.com/alvarotrigo/fullPage.js
 *
 * @license This code has been bought from www.alvarotrigo.com/fullPage/extensions/ and it is not free to use or distribute.
 * Copyright (C) 2016 alvarotrigo.com - A project by Alvaro Trigo
 */
window.fp_parallaxExtension = function () {
  var f,
      d,
      n,
      c,
      o,
      p,
      s,
      l,
      e,
      t,
      i = this,
      a = window.fp_utils,
      r = window.fullpage_api,
      u = a,
      v = a.$,
      m = r.getFullpageData(),
      g = m.options,
      x = m.internals,
      h = ".fullpage-wrapper",
      E = "active",
      b = "." + E,
      S = ".fp-section",
      y = S + b,
      w = "fp-slide",
      L = "." + w,
      A = L + b,
      M = "fp-notransition",
      N = ".fp-bg",
      R = "reveal",
      T = "cover",
      I = "fp-parallax-stylesheet",
      C = "fp-parallax-transitions",
      z = "#" + C,
      O = "fp-parallax-transition-class",
      B = "#" + O,
      H = 0,
      F = !1,
      k = !1,
      q = !0,
      W = !0,
      _ = !1,
      V = !1,
      G = !1,
      X = !1,
      Y = !1,
      D = !0 === g.parallax || "slides" === g.parallax,
      P = !0 === g.parallax || "sections" === g.parallax,
      U = u.closest,
      $ = u.addClass,
      j = u.removeClass,
      J = u.hasClass,
      K = u.css,
      Q = u.nextAll,
      Z = u.prevAll;function ee(e) {
    return { cover: { offsetNormal: e ? 0 : d }, reveal: { offsetNormal: e ? -d : 0 } };
  }function te(e) {
    return { cover: { offsetNormal: e ? 0 : n }, reveal: { offsetNormal: e ? -n : 0 } };
  }function ne(e) {
    return e * c / 100;
  }function oe(e) {
    return e * o / 100;
  }function ie() {
    return window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName("body")[0].clientWidth;
  }function ae() {
    s && Ae(v(y).length ? v(y)[0] : v(S)[0], 0);
  }function re() {
    if (P) {
      var e = v(y).length ? v(y)[0] : v(S)[0],
          t = f === R,
          n = t ? Q(e) : Z(e),
          o = t ? Z(e) : Q(e);n.forEach(function (e) {
        Ae(e, ee(t)[f].offsetNormal, "silent");
      }), o.forEach(function (e) {
        Ae(e, 0, "silent");
      });
    }D && v(S).forEach(function (e) {
      v(L, e).length && le(v(A, e).length ? v(A, e)[0] : v(L, e)[0]);
    });
  }function le(e) {
    var t = f === R,
        n = t ? Q(e) : Z(e),
        o = t ? Z(e) : Q(e);n.forEach(function (e) {
      Me(e, te(t)[f].offsetNormal, "silent");
    }), o.forEach(function (e) {
      Me(e, 0, "silent");
    });
  }function se(e) {
    var t = e.detail;o = ie(), t && !g.scrollBar ? (he(), Ee()) : be();
  }function fe(e) {
    i.destroy(), _ = !1;
  }function de() {
    v(".fp-scrollable").forEach(function (e) {
      var t = v(N, e)[0];(v(".fp-scrollable", e).length || J(e, "fp-scrollable")) && null != t && u.prependTo(e.parentNode, t);
    });
  }function ce(e) {
    e.detail ? be() : X = !0;
  }function pe(e) {
    e.detail, v(N).forEach(function (e) {
      e.setAttribute("data-final-x", 0), e.setAttribute("data-final-y", 0);
    }), p = v(S), re();
  }function ue(e) {
    e.detail.leavingSection, e.detail.destination, k = Y = !0;
  }function ve(e) {
    var t = e.detail.leavingSection,
        n = e.detail.destination;Ae(t, ee(F)[f].offsetNormal, "silent");var o = v(L, t);o.length && o.forEach(function (e) {
      e !== n && Ae(e, 0, "silent");
    }), i.afterSlideLoads(v(L, t)[0]), Y = !1;
  }function me(e) {
    var t = e.detail;V = !0, le("left" === t.xMovement ? v(L, v(y)[0])[0] : u.last(v(L, v(y)[0]))), setTimeout(function () {
      i.applyHorizontal(t);
    });
  }function ge(e) {
    var t = e.detail;G = !0, re(), setTimeout(function () {
      i.apply(t);
    });
  }function xe() {
    _ && (g.scrollBar || !g.autoScrolling || x.usingExtension("dragAndMove")) && function () {
      var e = x.usingExtension("dragAndMove") ? Math.abs(window.fp_dragAndMoveExtension.getCurrentScroll()) : u.getScrollTop(),
          t = e < H,
          n = u.index(v(y)[0], S),
          o = c + e;H = e;for (var i = 0; i < p.length; ++i) {
        var a = p[i],
            r = c + a.offsetTop;!t && a.offsetTop <= o ? n = i : t && e <= r && a.offsetTop < e && p.length > i + 1 && (n = i + 1);
      }var l = (c - (p[n].offsetTop - e)) * d / c;f !== R && (n -= 1);var s = f !== R ? l : -d + l;-1 < n && Ae(v(S)[n], s), 0 <= n - 1 && Ae(p[n - 1], ee(!1)[f].offsetNormal), void 0 !== p[n + 1] && Ae(p[n + 1], ee(!0)[f].offsetNormal);
    }();
  }function he() {
    var e = ".fp-bg{transition: transform " + g.scrollingSpeed + "ms " + g.easingcss3 + ";}.fp-slide, .fp-section{transition: background-position " + g.scrollingSpeed + "ms " + g.easingcss3 + ";}";g.autoScrolling && !g.scrollBar && Ne(C, e);
  }function Ee() {
    var e = ".fp-bg-animate{ transition: all " + g.scrollingSpeed + "ms " + g.easingcss3 + "}";Ne(O, e);
  }function be() {
    u.remove(v(z));
  }function Se() {
    clearTimeout(t), t = setTimeout(ye, 350);
  }function ye() {
    c = u.getWindowHeight(), o = ie(), d = ne(g.parallaxOptions.percentage), n = oe(g.parallaxOptions.percentage), ae(), re(), we();
  }function we() {
    K(v(N), { height: c + "px" });
  }function Le(e) {
    return Math.round(2 * e) / 2;
  }function Ae(e, t, n) {
    var o = Le(t),
        i = v(L, e);if (i.length) {
      var a = v(A, e)[0];e = null != a ? a : i[0];
    }if (s) K(e, { "background-position-y": o + "px" });else if (!J(e, w) || J(e, E) || void 0 !== n) {
      var r = v(N, e)[0];if (r) {
        var l = null != r.getAttribute("data-final-x") ? r.getAttribute("data-final-x") : 0;u.toggleClass(r, M, void 0 !== n), K(r, { transform: "translateX(" + l + "px) translateY(" + o + "px)" }), r.setAttribute("data-final-x", l), r.setAttribute("data-final-y", o);
      }
    }
  }function Me(e, t, n) {
    var o = Le(t),
        i = s ? e : v(N, e)[0];if (i) if (!g.scrollBar && g.autoScrolling || $(i, "fp-bg-animate"), s) u.toggleClass(i, M, void 0 !== n), K(i, { "background-position-x": o + "px" });else {
      var a = 0,
          r = i.getAttribute("data-final-y");"none" !== r && null != r && (a = r), u.toggleClass(i, M, void 0 !== n || Y), K(i, { transform: "translateX(" + o + "px) translateY(" + a + "px)" }), i.setAttribute("data-final-x", o), i.setAttribute("data-final-y", a);
    }
  }function Ne(e, t) {
    if (!v("#" + e).length) {
      var n = document.head || document.getElementsByTagName("head")[0];u.appendTo((o = e, i = t, (a = document.createElement("style")).type = "text/css", a.id = o, a.styleSheet ? a.styleSheet.cssText = i : a.appendChild(document.createTextNode(i)), a), n);
    }var o, i, a;
  }e = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame, window.requestAnimationFrame = e, i.apply = function (e) {
    if (P && (X && he(), !e.localIsResizing && !g.scrollBar && g.autoScrolling)) if (("up" === e.yMovement || e.sectionIndex) && (!e.isMovementUp || e.leavingSection - 1) || !g.continuousVertical || G) {
      var t = ee(F = "up" === e.yMovement)[f].offsetNormal;Ae(v(S)[e.sectionIndex], 0), Ae(v(S)[e.leavingSection - 1], t), q = 1 === Math.abs(e.leavingSection - 1 - e.sectionIndex);for (var n = Math.min(e.leavingSection - 1, e.sectionIndex) + 1; n < Math.max(e.leavingSection - 1, e.sectionIndex); n++) {
        Ae(v(S)[n], 0, "silent");
      }
    } else ;
  }, i.applyHorizontal = function (e) {
    if (D && (!e.localIsResizing || Y) && "none" != e.xMovement) if ((l = void 0 !== e.direction && e.direction !== e.xMovement) && g.continuousHorizontal && !V) l = !1;else {
      var t = te(k = l ? "left" === e.direction : "left" === e.xMovement)[f].offsetNormal;if (Me(v(L, e.section)[e.slideIndex], 0), Me(v(L, e.section)[e.prevSlideIndex], t), !(W = 1 === Math.abs(e.slideIndex - e.prevSlideIndex)) && !Y) for (var n = Math.min(e.slideIndex, e.prevSlideIndex) + 1; n < Math.max(e.slideIndex, e.prevSlideIndex); n++) {
        Me(v(L, e.section)[n], 0, "silent");
      }
    }
  }, i.init = function () {
    var e;c = u.getWindowHeight(), o = ie(), f = g.parallaxOptions.type, d = ne(g.parallaxOptions.percentage), n = oe(g.parallaxOptions.percentage), p = v(g.sectionSelector), s = "background" === g.parallaxOptions.property, we(), (e = v(h)[0]).addEventListener("setAutoScrolling", se), e.addEventListener("destroy", fe), e.addEventListener("onScroll", xe), e.addEventListener("afterResponsive", pe), e.addEventListener("onGrab", ce), e.addEventListener("onContinuousVertical", ge), e.addEventListener("onResize", Se), e.addEventListener("afterRender", de), e.addEventListener("afterRebuild", de), e.addEventListener("onResetSliders", ue), D && e.addEventListener("onContinuosHorizontal", me), e.addEventListener("onEndResetSliders", ve), s || (Ne(I, ".fp-bg{top:0;bottom:0;width: 100%;position:absolute;z-index: -1;}.fp-section, .fp-slide, .fp-section.fp-table, .fp-slide.fp-table, .fp-section .fp-tableCell, .fp-slide .fp-tableCell {position:relative;overflow: hidden;}"), he()), Ee(), ae(), re(), _ = !0;
  }, i.destroy = function () {
    be(), u.remove(v(B)), d = ne(0), n = oe(0), v(S).length && (re(), u.css(v(N), { height: "" })), clearTimeout(t);var e = v(h)[0];e && (e.removeEventListener("setAutoScrolling", se), e.removeEventListener("destroy", fe), e.removeEventListener("onScroll", xe), e.removeEventListener("afterResponsive", pe), e.removeEventListener("onGrab", ce), e.removeEventListener("onContinuousVertical", ge), e.removeEventListener("onResize", Se), e.removeEventListener("afterRender", de), e.removeEventListener("afterRebuild", de), e.removeEventListener("onResetSliders", ue), D && e.removeEventListener("onContinuosHorizontal", me), e.removeEventListener("onEndResetSliders", ve));
  }, i.setOption = function (e, t) {
    "offset" === e ? (g.parallaxOptions.percentage = t, d = ne(t), n = oe(t)) : "type" === e && (g.parallaxOptions.type = t, f = t), re();
  }, i.applyProperties = Ae, i.afterSlideLoads = function (e) {
    var t,
        n = void 0 !== e ? e : v(A, v(y)[0])[0],
        o = U(n, S);if ((s ? (t = o, v(L, t).length ? v(L, t) : [t]) : v(N, o)).forEach(function (e) {
      j(e, "fp-bg-animate");
    }), (V || l) && (le(n), V = !1), !W) {
      var i = te(k)[f].offsetNormal,
          a = n,
          r = k ? Q(a) : Z(a);(f === R && k || f === T && !k || Y) && r.forEach(function (e) {
        Me(e, i, "silent");
      });
    }
  }, i.afterLoad = function () {
    if ((!g.scrollBar || !g.autoScrolling || x.usingExtension("dragAndMove")) && ((G || l) && (re(), G = !1), !q)) {
      var t = ee(F)[f].offsetNormal,
          e = F ? Q(v(y)[0]) : Z(v(y)[0]);(f === R && F || f === T && !F) && e.forEach(function (e) {
        Ae(e, t, "silent");
      });
    }
  }, i.c = x.c;var Re = i["common".charAt(0)];return "complete" === document.readyState && Re("parallax"), window.addEventListener("load", function () {
    Re("parallax");
  }), i;
};